<template>
    <div class="my-send-select-page layout-sub-page">
        <!-- 1. 标题部分 -->
        <title-bar 
            v-bind:className="'my-send-select-title-bar'"
            v-bind:titleData="titleData"
            v-bind:backFunc="clickBack">
        </title-bar>

        <div class="my-send-select-content">
            <div class="my-send-share-content">
                <p class="code-title">在其它手机输入下列密码可以批量接收记录</p>
                <p class="share-code">{{sendShareCode}}</p>
            </div>
            <div class="my-send-share-sub-note">
                有效期为24小时，可以将密码直接告诉接收人或者通过右上角的分享发送给他们。
            </div>
        </div>
    </div>
</template>

<script>
import TitleBar from '../../components/TitleBar.vue'
export default {
    name: 'MySendGetCode',
    components: { TitleBar },
    computed: {
        sendShareCode() {
            return this.$store.state.record.sendShareCode;
        }
    },
    data() {
        return {
            titleData: {
                'titleText': '共享接收密码', 
                'hideButton': true, 
                'showCancel': false
            },
        }
    },
    methods: {
        clickBack() {
            this.$store.dispatch('group/resetChooseGroupData');
            this.$store.dispatch('group/resetSelectedGroupListData');
            this.$store.dispatch('chooserecord/resetData');
            this.$router.replace('/my/sendbzselect');
        },
    }
}
</script>>